import { formatDate } from "../../utils/dateUtils";

export default function AccountInfo({ data }) {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h2 className="font-semibold mb-2">Account Info</h2>
      <div className="space-y-2 text-sm">
        <div>
          <span className="font-bold">Created:</span>{" "}
          {formatDate(data.createdAt)}
        </div>
        <div>
          <span className="font-bold">Last Updated:</span>{" "}
          {formatDate(data.updatedAt)}
        </div>
        <div>
          <span className="font-bold">Last Login:</span>{" "}
          {formatDate(data.lastLogin)}
        </div>
        <div>
          <span className="font-bold">Failed Login Attempts:</span>{" "}
          {data.failedLoginAttempts}
        </div>
      </div>
    </div>
  );
}
